import { css } from '@emotion/css'
import { spacing, mediaQueryHelper, breakpoint, colors, hexToRgba } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    padding: spacing.medium,
    gap: spacing.default,
    display: 'grid',

    [mediaQueryHelper(breakpoint.tablet)]: {
      gridTemplateColumns: '1fr auto',
      border: `1px solid ${colors.geyser}`,
      padding: spacing.large,
      transition: 'box-shadow 200ms',

      '&:hover': {
        boxShadow: `1px 3px 10px ${hexToRgba(colors.black, 0.1)}`,
      },
    },
  }),

  buttonWrapper: css({
    display: 'grid',
    alignItems: 'center',
    gap: spacing.default,

    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      a: {
        gridRow: '1/2',
      },
    },
  }),
}

export default styles
